import { NameSummaryFormGB } from '@/components/slides/DataSummary/gb/SummaryForms/NameSummaryFormGB.tsx';
import { ContactSummaryFormGB } from '@/components/slides/DataSummary/gb/SummaryForms/ContactSummaryFormGB.tsx';
import { AddressSummaryFormGB } from '@/components/slides/DataSummary/gb/SummaryForms/AddressSummaryFormGB.tsx';
import { PersonalInfoSummaryFormGB } from '@/components/slides/DataSummary/gb/SummaryForms/PersonalInfoSummaryFormGB.tsx';
import { AncestrySummaryFormGB } from '@/components/slides/DataSummary/gb/SummaryForms/AncestrySummaryFormGB.tsx';

export const SummaryFormsGB = () => {
  return (
    <>
      <NameSummaryFormGB />
      <ContactSummaryFormGB />
      <AddressSummaryFormGB />
      <PersonalInfoSummaryFormGB />
      <AncestrySummaryFormGB />
    </>
  );
};
